import { createContext, useContext } from 'react'

// Context for the sound clip domain (rich editor Sound Library).
// Kept distinct from SearchContext and UserSearchContext: the three search
// trees are independent and share no state.

export const EMPTY_SOUND_RESULT = { hits: [], hitCount: 0 }

const defaultValue = {
  isSearching: false, // a request for the active categories is in flight
  counts: {}, // category name -> total clips in that category
  getResults: () => EMPTY_SOUND_RESULT, // category name -> { hits, hitCount }
}

export const SoundSearchContext = createContext(defaultValue)

export function useSoundSearchContext() {
  return useContext(SoundSearchContext)
}
